import { atom } from 'jotai';

export interface IFullscreenLoaderAtom {
  title: string;
  subtitle?: string;
}

export const fullscreenLoaderAtom = atom<IFullscreenLoaderAtom | false>(false);
